import classNames from 'classnames'
import { useTranslation } from 'next-i18next/pages'
import styles from './SalesPrices.module.scss'
import simulationStyles from '../RegistrationSideCard.module.scss'
import { formatAmount } from 'utils/format'
import PriceDisplay from 'features/simulation/components/proposition-card/price-display/PriceDisplay'
import { FixedPricesSectionProps } from 'features/registration/components/registration-side-card/sales-prices-section/types'
import { useStoreSelector } from 'hooks/store'
import SimulationRegistrationSideCardLayout from 'components/simulation-registration-side-card-layout/SimulationRegistrationSideCardLayout'
import { SIMULATION_TYPES } from '@boltenergy-be/shared'

const SalesPricesSection = ({ setShowFixedPricesDrawer }: FixedPricesSectionProps) => {
  // REDUX STORE
  const { fixedPrices, inputs } = useStoreSelector((store) => store.customer)
  const { needsGas } = inputs.deliveryAddress

  // I18N
  const { t } = useTranslation(['simulationCard', 'common'])

  return (
    <section className={classNames(simulationStyles.section, styles['sales-section'])}>
      <div className={classNames(simulationStyles['section-header'], styles.header)}>
        <span className={simulationStyles['section-title']}>{t('sales.prices.title', 'Jouw voorschot')}</span>

        <SimulationRegistrationSideCardLayout.Action onClick={() => setShowFixedPricesDrawer(true)}>
          {t('common:change', 'Wijzig')}
        </SimulationRegistrationSideCardLayout.Action>
      </div>

      {fixedPrices && (
        <>
          <PriceDisplay label={t('common:perMonthIncl', 'Gas (incl. btw)')} {...{ fixedPrices }} />

          <span className={simulationStyles['fixed-product-price']}>
            {t('common:electricity', 'Elektriciteit')}: &euro; {formatAmount(fixedPrices.electricity)}
          </span>
          {needsGas && (
            <span className={simulationStyles['fixed-product-price']}>
              {t('common:gas', 'Gas')}: &euro; {formatAmount(fixedPrices.gas)}
            </span>
          )}
        </>
      )}

      {inputs.simulation.chosenSimulationType === SIMULATION_TYPES.eav && (
        <p className={classNames(simulationStyles['price-explanation'], styles.explanation)}>
          {t(
            'sales.eav.explanation',
            'We baseren jouw voorschot op de verbruiksgegevens, die we voor jouw adres van de netbeheerder doorkrijgen.'
          )}
        </p>
      )}
    </section>
  )
}

export default SalesPricesSection
